var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOffIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_163_1004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.20649 3.85248L11.3822 1.78499L11.0022 0.974214C10.7536 0.447206 10.1472 0.229576 9.64793 0.492013L3.22412 3.85248H4.20649Z",
    fill: "#111F3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6097 1.84473C13.5208 1.84473 13.4319 1.85754 13.3429 1.88314L11.6572 2.36961L6.50879 3.85248H12.3525H14.8994L14.584 2.63204C14.4627 2.15624 14.0544 1.84473 13.6097 1.84473Z",
    fill: "#111F3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9524 4.59926H15.722H15.4086H15.0953H12.7041H3.91735H2.76519H1.79495H1.61505H1.01269C0.693318 4.59926 0.40831 4.75501 0.222347 5.00038C0.137451 5.11346 0.0727681 5.24362 0.0363841 5.38657C0.0141494 5.47618 0 5.57006 0 5.66607V5.79409V7.01026V17.5525C0 18.1414 0.452779 18.6194 1.01067 18.6194H15.9504C16.5083 18.6194 16.961 18.1414 16.961 17.5525V14.5761H10.9637C10.0157 14.5761 9.24559 13.7632 9.24559 12.7625V11.7853V11.4546V11.1239V10.3899C9.24559 9.8992 9.43154 9.45329 9.73273 9.12685C9.99955 8.83665 10.3573 8.64036 10.7576 8.59129C10.8243 8.58277 10.893 8.57848 10.9617 8.57848H16.1202H16.4335H16.7468H16.961V5.66607C16.9631 5.07719 16.5103 4.59926 15.9524 4.59926Z",
    fill: "#111F3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6706 9.59836C17.5695 9.50021 17.4503 9.42553 17.3169 9.37646C17.2137 9.34021 17.1046 9.31887 16.9894 9.31887H16.9631H16.9429H16.6296H15.4997H10.9638C10.4059 9.31887 9.95312 9.79678 9.95312 10.3857V10.9169V11.2477V11.5784V12.7604C9.95312 13.3493 10.4059 13.8272 10.9638 13.8272H16.9631H16.9894C17.1046 13.8272 17.2138 13.8059 17.3169 13.7696C17.4503 13.7227 17.5695 13.6459 17.6706 13.5477C17.8727 13.3535 18.0001 13.0719 18.0001 12.7604V10.3857C18.0001 10.0742 17.8727 9.79249 17.6706 9.59836ZM13.0741 11.7853C13.0741 12.0798 12.8477 12.3187 12.5687 12.3187H12.2332C11.9542 12.3187 11.7279 12.0798 11.7279 11.7853V11.4311C11.7279 11.2605 11.8026 11.1089 11.9219 11.0129C12.0088 10.9425 12.116 10.8977 12.2332 10.8977H12.3181H12.5687C12.8477 10.8977 13.0741 11.1367 13.0741 11.4311V11.7853Z",
    fill: "#111F3E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_163_1004"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffIcon);
export default __webpack_public_path__ + "static/media/offIcon.5b75f2710b5a2f61dd43513a70998144.svg";
export { ForwardRef as ReactComponent };